import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function Kanjabandb() {
    return (
        <React.Fragment>
            <section className='Proyect'>
                <h2 className="">Kanjaban data base</h2>
                <div className='folder-porfolio'>
                    <div className="imageProyect imageKanjaban"></div>
                    <div className="list" >
                        {tecno.filter(tec => tec.T === 'MySql').map(tec => (
                            <div key={tec.T}>
                                <a href={tec.L} target="_blank" rel="noreferrer">
                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>
                        ))}
                    </div>
                    <p className='white'>
                        This database in MySql belongs to the kanjaban application.
                    </p>
                    <a href="https://github.com/BrandonGrimaldoM/KanjabanDataBase" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>
                <div className='after'>
                    <Link to="/data-base" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>
            </section>
        </React.Fragment>
    );
}
export default Kanjabandb;